import React from 'react';
import TextInput from './TextInput.js';

const TextGroup = ({
  formik,
  disabled,
  groupLabel,
  inputLabels,
  name,
  placeholder,
  style,
  onChange,
  maxLength,
  overFlow,
  length,
  additionalContent,
}) => {
  return (
    <>
      <div className="text-group">
        <h2 className="group-label">{groupLabel}</h2>
        {additionalContent}
        {inputLabels.map((label, index) => (
          <React.Fragment key={index}>
            {label && (
              <TextInput
                name={name[index]}
                label={label}
                type="textarea"
                value={formik.values[name[index]]}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                style={style}
                error={formik.errors[`${name}[${index}]`]}
                touched={formik.touched[`${name}[${index}]`]}
                required={false}
                maxLength={maxLength[index]}
                overFlow={overFlow[index]}
                length={length[index]}
                className={`col-md-8`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default TextGroup;
